import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { MobilePaymentCheckDto } from '../../../models/dtos/mobilePaymentCheck.dto';
import { Errors } from '../../errors';
import CardsRequest from './cards.repository';

type InitialState = {
  loading: boolean;
  data?: any;
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const Cards = createAsyncThunk(
  'Cards',
  async () => {
    return await CardsRequest();
  }
);

const CardsSlice = createSlice({
  name: 'Cards',
  initialState,
  reducers: {
    CardsReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Cards.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      Cards.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(Cards.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default CardsSlice.reducer;
export const { CardsReset } = CardsSlice.actions;
